<button (click)="this.enterRaw()"></button>
<label>{{x_label}}
    <input [(ngModel)]="cords.x" type="number" />
</label>
<label>{{y_label}}
    <input [(ngModel)]="cords.y" type="number" />
</label>